/// <reference path="../../../../common-types.d.ts" />
/// <reference path="../../../../interfaces.d.ts" />
/// <reference path="../../../../types.d.ts" />
/// <reference path="../../../../data/data-models.d.ts" />
import "./AddTracker.scss";
import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Row, Col } from "react-bootstrap";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
    putTracker,
    putAttachment,
    deleteAttachment,
    postAttachment,
} from "../../../../data/TrackersRepository";
import { ClaimAutoCompleteTextBox } from "../../../shared-components/autocomplete/ClaimAutoCompleteTextBox";
import { AppContext } from "../../../AppStateProvider";
import { loadTrackersGrid } from "../helpers";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { getAllTrackerUsers } from "../../../../service/TrackersService";
import { getAuthStatus } from "../../../../data/IdentityRepository";
import { getTrackerUsers } from "../../../../data/TrackersRepository";
var Enumerable = require("linq");

declare interface IEditTrackerModalProps {
    isOpen: boolean;
    closeModal: () => void;
    setError: (error: boolean, errorMsg: string) => void;
    viewAllTrackers: boolean;
}

declare interface IEditTrackerModalState {
    id: number;
    description: string;
    classification?: INameIdPair;
    billingCode?: INameIdPair;
    // claim?: INameIdPair,
    claim?: string;
    claimId?: number;
    claimOptions?: INameIdPair[];
    totalAmount?: number;
    file?: File;
    user: string;
    userId: number;
    savedFileName?: string;
    attachmentUri?: string;
    hasAttachment: boolean;
    descriptionError: boolean;
    classificationError: boolean;
    billingCodeError: boolean;
    claimError: boolean;
    amountError: boolean;
    fileError: boolean;
    totalAmountErrorText: string;
    expenseDate: Date;
    expenseDateError: boolean;
    trackerUsers: ITrackerUser[];
}

export class EditTrackerModal extends React.Component<
    IEditTrackerModalProps,
    IEditTrackerModalState
> {
    private fileRef = React.createRef<HTMLInputElement>();
    static contextType = AppContext;
    context!: IReactContext<IAppState>;
    state = {
        id: undefined,
        description: "",
        classification: { id: 6, name: "Investigation Job Related" }, // Always set to fixed classification
        billingCode: undefined,
        // claim: undefined,
        claim: undefined,
        claimId: undefined,
        claimOptions: undefined,
        totalAmount: undefined,
        file: undefined,
        user: undefined,
        userId: undefined,
        savedFileName: undefined,
        attachmentUri: undefined,
        hasAttachment: false,
        descriptionError: false,
        classificationError: false,
        billingCodeError: false,
        claimError: false,
        amountError: false,
        fileError: false,
        totalAmountErrorText: "",
        expenseDate: undefined,
        expenseDateError: false,
        trackerUsers: [],
    };

    async componentDidMount() {
        const item = this.context.state.editModal.item;

        const claimOptions = [item.claim];

        const getAllTrackerUsersResponse = await getAllTrackerUsers();

        if (getAllTrackerUsersResponse.error == true) {
            this.props.setError(
                getAllTrackerUsersResponse.error,
                getAllTrackerUsersResponse.errorMsg
            );
        }

        const trackerUsers = getAllTrackerUsersResponse.trackerUsers;

        var user = Enumerable.from(trackerUsers)
            .where((i) => i.id == item.userId)
            .firstOrDefault();

        // Always set classification to "Investigation Job Related" with ID 6
        const fixedClassification = {
            id: 6,
            name: "Investigation Job Related",
        };

        this.setState({
            ...item,
            classification: fixedClassification,
            claimOptions,
            user: user,
            trackerUsers: trackerUsers,
        });
    }

    hasError = (state) => {
        const {
            descriptionError,
            billingCodeError,
            claimError,
            amountError,
            fileError,
            expenseDateError,
        } = state;
        return (
            descriptionError ||
            billingCodeError ||
            claimError ||
            amountError ||
            fileError ||
            expenseDateError
        );
    };

    handleSave = async () => {
        const newState = {
            ...this.state,
        };

        this.validateFormValue(newState, "description");
        // Classification is always fixed, no need to validate
        this.validateFormValue(newState, "billingCode");
        this.validateFormValue(newState, "totalAmount");
        this.validateFormValue(newState, "claim");
        this.validateFormValue(newState, "expenseDate");

        // do not require file if billing code selected is phone/internet or tolls
        // attachment url must also be empty or null in order to show error
        if (
            (this.state.attachmentUri == null ||
                this.state.attachmentUri.length == 0) &&
            newState.billingCode.id != 6215 &&
            newState.billingCode.id != 6230 &&
            newState.billingCode.id != 6200 &&
            newState.billingCode.id != 6235 &&
            newState.billingCode.id != 6255
        ) {
            this.validateFormValue(newState, "file");
        } else {
            newState.fileError = false;
        }

        if (this.hasError(newState)) {
            this.setState(newState);
            return;
        }

        this.context.set({ trackers: { loadingLedgers: true } });

        const response = await putTracker(this.state.id, this.getPayload());

        if (response.data.error == true) {
            this.props.setError(response.data.error, response.data.errorMsg);

            return;
        }

        var attachmentError = false;
        var attachmentErrorMsg = "";

        // handle attachments
        if (this.state.hasAttachment) {
            if (this.state.file) {
                // update
                var putAttachmentResponse = await putAttachment(
                    this.state.id,
                    this.state.file
                );

                attachmentError = putAttachmentResponse.data.error;
                attachmentErrorMsg = putAttachmentResponse.data.errorMsg;
            } else if (!this.state.savedFileName) {
                // delete
                var deleteAttachmentResponse = await deleteAttachment(
                    this.state.id
                );

                attachmentError = deleteAttachmentResponse.data.error;
                attachmentErrorMsg = deleteAttachmentResponse.data.errorMsg;
            }
        } else {
            if (this.state.file) {
                // add
                var postAttachmentResponse = await postAttachment(
                    this.state.id,
                    this.state.file
                );

                attachmentError = postAttachmentResponse.data.error;
                attachmentErrorMsg = postAttachmentResponse.data.errorMsg;
            }
        }

        if (attachmentError == true) {
            this.props.setError(attachmentError, attachmentErrorMsg);

            return;
        }

        this.reset();

        var viewAllTrackerUsers = this.props.viewAllTrackers == true;

        const usersResponse = await getTrackerUsers(viewAllTrackerUsers);

        if (usersResponse.data.error == true) {
            this.props.setError(
                usersResponse.data.error,
                usersResponse.data.errorMsg
            );

            return;
        }

        const allowedUsers = usersResponse.data.trackerUsers;

        this.context.set({
            user: {
                allowedUsers: allowedUsers,
            },
        });

        this.props.closeModal();
        var loadTrackersGridResponse = await loadTrackersGrid(
            this.context,
            this.props.viewAllTrackers
        );

        if (loadTrackersGridResponse.error == true) {
            this.props.setError(
                loadTrackersGridResponse.error,
                loadTrackersGridResponse.errorMsg
            );

            return;
        }
    };

    getPayload = () => {
        const {
            description,
            classification,
            billingCode,
            claimId,
            totalAmount,
            expenseDate,
            userId,
        } = this.state;
        return {
            description,
            billingCodeClassificationId:
                typeof classification !== "undefined"
                    ? classification.id
                    : undefined,
            billingCodeId:
                typeof billingCode !== "undefined" ? billingCode.id : undefined,
            claimId: typeof claimId !== "undefined" ? claimId : undefined,
            expenseDate,
            totalAmount,
            userId,
        };
    };

    handleCancel = () => {
        this.reset();
        this.props.closeModal();
    };

    handleChange = (name) => (e) => {
        const newState = {
            ...this.state,
            [name]: e.target.value,
        };

        if (name == "user") {
            newState.userId = e.target.value.id;
        }

        this.validateFormValue(newState, name);

        if (name == "billingCode") {
            if (
                newState.billingCode == null ||
                newState.billingCode.id == 6215 ||
                newState.billingCode.id == 6230 ||
                newState.billingCode.id == 6200 ||
                newState.billingCode.id == 6235 ||
                newState.billingCode.id == 6255
            ) {
                newState.fileError = false;
            }
        }

        this.setState(newState);
    };

    handleClaimChange = (e) => {
        if (e.value === undefined) {
            this.setState({
                ...this.state,
                claim: undefined,
                claimId: undefined,
                claimError: false,
            });
            return;
        }

        const newState = {
            ...this.state,
            claim: e.value.name,
            claimId: e.value.id,
        };

        this.validateFormValue(newState, "claim");

        this.setState(newState);
    };

    handleFileChange = (e) => {
        const file = e.target.files[0];
        this.state.fileError = false;
        this.setState({
            ...this.state,
            file,
            savedFileName: undefined,
            attachmentUri: undefined,
        });
    };

    clearFile = (e) => {
        e.preventDefault();
        this.setState({
            ...this.state,
            file: undefined,
            savedFileName: undefined,
            attachmentUri: undefined,
        });
    };

    validateFormValue = (state, prop) => {
        if (prop === "claim") {
            state.claimError =
                state.claim &&
                state.claim.length > 0 &&
                state.claim.length !== 9;
            return;
        }

        if (prop === "totalAmount") {
            if (
                state.totalAmount == null ||
                state.totalAmount == "" ||
                state.totalAmount <= 0
            ) {
                state["amountError"] = true;
                state["totalAmountErrorText"] =
                    "Total Amount must be value greater than $0.00.";
            } else {
                state["amountError"] = false;
                state.totalAmount = parseFloat(state.totalAmount.toFixed(2));
            }
        }

        if (!state[prop]) {
            state[`${prop}Error`] = true;
        } else {
            state[`${prop}Error`] = false;
        }
    };

    getClassificationOptions = () => {
        return this.context.state.user.allowedClassifications;
    };

    getBillingCodeOptions = () => {
        return this.context.state.user.billingCodes.map((c) => ({
            ...c,
            text: `${c.id} - ${c.name}`,
        }));
    };

    reset = () => {
        this.context.set({ editModal: { item: undefined } });
        this.setState({
            description: "",
            classification: { id: 6, name: "Investigation Job Related" }, // Always set to fixed classification
            billingCode: undefined,
            claim: undefined,
            totalAmount: undefined,
            file: undefined,
            savedFileName: undefined,
            attachmentUri: undefined,
            hasAttachment: false,
            descriptionError: false,
            classificationError: false,
            billingCodeError: false,
            claimError: false,
            amountError: false,
            fileError: false,
            totalAmountErrorText: "",
            expenseDate: undefined,
            expenseDateError: false,
        });
    };

    handleClose = () => {
        this.reset();
        this.props.closeModal();
    };

    getAttachmentName = () => {
        if (this.state.file) {
            return this.state.file.name;
        }
        if (this.state.savedFileName) {
            return this.state.savedFileName;
        }
        return "";
    };

    render() {
        const { isSuperAdmin } = this.context.state.user;

        return (
            <div>
                {this.props.isOpen && (
                    <Dialog title={"Edit Tracker"} onClose={this.handleClose}>
                        <div className="add-tracker-component">
                            <Row className="tracker-form-row">
                                <Col sm={6}>
                                    Assigned User:
                                    <br />
                                    <DropDownList
                                        value={this.state.user}
                                        onChange={this.handleChange("user")}
                                        data={this.state.trackerUsers}
                                        dataItemKey="id"
                                        textField="userFullName"
                                        disabled={!isSuperAdmin}
                                        popupSettings={{
                                            className: "cls-option",
                                        }}
                                    />
                                </Col>
                                <Col sm={6} className="tracker-form-col">
                                    {this.state.claimOptions !== undefined && (
                                        <ClaimAutoCompleteTextBox
                                            onChange={this.handleClaimChange}
                                            value={this.state.claim}
                                            label="Claim"
                                            textField="text"
                                            valid={!this.state.claimError}
                                            setError={this.props.setError}
                                        />
                                    )}
                                </Col>
                            </Row>
                            <Row className="tracker-form-row">
                                <Col sm={6}>
                                    <Input
                                        value={this.state.description}
                                        onChange={this.handleChange(
                                            "description"
                                        )}
                                        label="Description"
                                        valid={!this.state.descriptionError}
                                    />
                                </Col>
                                <Col sm={6} className="tracker-form-col">
                                    <DropDownList
                                        value={this.state.billingCode}
                                        onChange={this.handleChange(
                                            "billingCode"
                                        )}
                                        label={"Billing Code"}
                                        data={this.getBillingCodeOptions()}
                                        dataItemKey="id"
                                        textField="text"
                                        popupSettings={{
                                            className: "cls-option",
                                        }}
                                        valid={!this.state.billingCodeError}
                                    />
                                </Col>
                            </Row>
                            <Row className="tracker-form-row">
                                <Col sm={3}>
                                    <NumericTextBox
                                        value={this.state.totalAmount}
                                        onChange={this.handleChange(
                                            "totalAmount"
                                        )}
                                        label="Total Amount"
                                        format="c2"
                                        min={0}
                                        className="full-width"
                                        valid={!this.state.amountError}
                                    />

                                    <span
                                        style={{
                                            visibility:
                                                this.state.amountError == true
                                                    ? "visible"
                                                    : "hidden",
                                            color: "red",
                                        }}
                                    >
                                        {this.state.totalAmountErrorText}
                                    </span>
                                </Col>
                                <Col sm={5}>
                                    <div style={{ marginTop: "-4px" }}>
                                        Expense Date: <br />
                                        <DatePicker
                                            value={this.state.expenseDate}
                                            className="expense-datepicker"
                                            title="Expense Date"
                                            onChange={this.handleChange(
                                                "expenseDate"
                                            )}
                                            valid={!this.state.expenseDateError}
                                        />
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <input
                                        type="file"
                                        id="contained-button-file"
                                        style={{ display: "none" }}
                                        onChange={this.handleFileChange}
                                        ref={this.fileRef}
                                        // accept=".json"
                                    />
                                    <label
                                        htmlFor="contained-button-file"
                                        style={{ paddingTop: "1rem" }}
                                    >
                                        <button
                                            className="btn btn-secondary pull-right"
                                            style={{
                                                borderColor:
                                                    this.state.fileError == true
                                                        ? "red"
                                                        : "",
                                            }}
                                            onClick={() =>
                                                this.fileRef.current.click()
                                            }
                                        >
                                            Choose File
                                        </button>
                                    </label>
                                    <div>
                                        {!!this.state.file && (
                                            <div>
                                                <div>
                                                    {this.getAttachmentName()} (
                                                    <a
                                                        href=""
                                                        onClick={this.clearFile}
                                                    >
                                                        {"Clear"}
                                                    </a>
                                                    )
                                                </div>
                                            </div>
                                        )}
                                        {!!this.state.savedFileName &&
                                            !!this.state.hasAttachment && (
                                                <div>
                                                    <div>
                                                        <a
                                                            href={
                                                                this.state
                                                                    .attachmentUri
                                                            }
                                                            target="_blank"
                                                        >
                                                            {
                                                                this.state
                                                                    .savedFileName
                                                            }
                                                        </a>{" "}
                                                        (
                                                        <a
                                                            href=""
                                                            onClick={
                                                                this.clearFile
                                                            }
                                                        >
                                                            {"Clear"}
                                                        </a>
                                                        )
                                                    </div>
                                                </div>
                                            )}
                                        <span
                                            style={{
                                                visibility:
                                                    this.state.fileError == true
                                                        ? "visible"
                                                        : "hidden",
                                                color: "red",
                                            }}
                                        >
                                            File attachment is required.
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <DialogActionsBar>
                            <button
                                className="k-button"
                                onClick={this.handleCancel}
                            >
                                Cancel
                            </button>
                            <button
                                className="k-button"
                                onClick={this.handleSave}
                            >
                                Save
                            </button>
                        </DialogActionsBar>
                    </Dialog>
                )}
            </div>
        );
    }
}
